module.exports = __webpack_public_path__ + "img/newInt-round-circle.13a2b5c5.svg";